import type { MealLogSummaryConfig, WidgetConfig } from "@/lib/schema";
import { getWidgetModule } from "@/widgets/registry";
import type { WeekWidgetModule } from "@/widgets/types";
import { SettingsEditor } from "./SettingsEditor";
import { validate } from "./validate";
import { WeekView } from "./WeekView";

function defaults(existing: WidgetConfig[]): MealLogSummaryConfig {
  const weekWidgets = existing.filter(
    (w) => getWidgetModule(w.kind)?.scope === "week",
  );
  const maxRow = weekWidgets.reduce((m, w) => Math.max(m, w.row), -1);
  const mealLogs = existing.filter((w) => w.kind === "meal-log");
  return {
    id: crypto.randomUUID(),
    kind: "meal-log-summary",
    label: "Matoversikt",
    row: maxRow + 1,
    column: 0,
    enabled: true,
    // Preselected when there is only one — the choice is only real with
    // several, and Save is gated on it either way.
    mealLogId: mealLogs.length === 1 ? mealLogs[0].id : "",
  };
}

export const mealLogSummary: WeekWidgetModule<MealLogSummaryConfig> = {
  kind: "meal-log-summary",
  label: "Matoversikt",
  scope: "week",
  scoring: "none",
  defaults,
  validate,
  SettingsEditor,
  WeekView,
};
